import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Approved' },
    { value: 2, label: 'Declined' },
    { value: 3, label: 'Pending' },
    { value: 4, label: 'Revoked' },
  ],
});
